<template>
  <div class="pg-drawer-search-table-tag">
    <template v-if="!multiple && value && getLabel(value)">
      <tag :closable="!disabled" @close="close(value)">{{ getLabel(value) }}</tag>
    </template>
    <template v-if="multiple && value?.length > 0">
      <Tag
        class="pg-drawer-search-table-tag__tag"
        v-for="tag in value"
        :key="getValueByPath(tag, rowConfig.keyField)"
        :closable="!disabled"
        @close="close(tag)"
        >{{ getLabel(tag) }}</Tag
      >
    </template>
    <Button
      class="pg-drawer-search-table-tag__button"
      type="text"
      @click="handleClick"
      v-if="!disabled"
      >选择</Button
    >
    <Button
      class="pg-drawer-search-table-tag__button"
      type="text"
      @click="clearAll"
      v-if="!disabled && multiple && value?.length > 0"
      >清空</Button
    >
    <PgDrawerSearchTable
      ref="tableRef"
      :visible.sync="visible"
      :selected="selected"
      :isSelection="multiple"
      v-bind="$attrs"
      v-on="$listeners"
      @on-ok-and-continue="onOk"
      @on-ok="onOk"
    ></PgDrawerSearchTable>
  </div>
</template>
<script setup>
import { ref, computed, watch } from 'vue'
import { Tag, Button } from 'element-ui'
import PgDrawerSearchTable from './drawer-search-table.vue'
import { getValueByPath } from '../../../utils/index'
import { useFormItemValidate } from '../../form/hook/use-form-item-validate'

const props = defineProps({
  value: [Array, Object],
  //是否多选
  multiple: {
    type: Boolean,
    default: true,
  },
  labelKey: {
    type: String,
    default: 'name',
  },
  labelPrefixKey: {
    type: String,
    default: null,
  },
  rowConfig: {
    type: Object,
    default: () => ({ keyField: 'id' }),
  },
  //是否禁用
  disabled: Boolean,
  validateCustom: {
    type: Boolean,
    default: true,
  },
})

const emit = defineEmits(['input'])

const selected = computed(() => (!props.multiple && props.value ? [props.value] : props.value))

const visible = ref(false)
const handleClick = () => {
  visible.value = !visible.value
}

const { formItemsChange } = useFormItemValidate()
watch(
  () => props.value,
  () => {
    if (!props.multiple) {
      props.validateCustom && formItemsChange()
      visible.value = false
    }
  }
)

const tableRef = ref(null)
const onOk = ({ type, data }) => {
  if (!props.multiple) {
    if (data.checked && data.records?.length > 1) {
      tableRef.value.setCheckboxRow(
        data.records.filter(
          (im) =>
            getValueByPath(im, props.rowConfig.keyField) !==
            getValueByPath(data.row, props.rowConfig.keyField)
        ),
        false
      )
    }
    emit('input', data.checked ? data.row : null)
  } else {
    let resVal = props.value ?? []
    const rows = type === 'ROW' ? [data.row] : data.row
    if (data.checked) {
      resVal = [
        ...resVal,
        ...rows.filter((im) =>
          resVal.every(
            (selectRow) =>
              getValueByPath(im, props.rowConfig.keyField) !==
              getValueByPath(selectRow, props.rowConfig.keyField)
          )
        ),
      ]
    } else {
      resVal = resVal.filter((im) =>
        rows.every(
          (row) =>
            getValueByPath(im, props.rowConfig.keyField) !==
            getValueByPath(row, props.rowConfig.keyField)
        )
      )
    }
    emit('input', resVal)
  }
}
const close = (item) => {
  const resVal = props.multiple
    ? props.value.filter(
        (im) =>
          getValueByPath(im, props.rowConfig.keyField) !==
          getValueByPath(item, props.rowConfig.keyField)
      )
    : null
  emit('input', resVal)
}
const clearAll = () => {
  emit('input', null)
}
const getLabel = (item) => {
  if (props.labelPrefixKey && getValueByPath(item, props.labelPrefixKey)) {
    return `(${getValueByPath(item, props.labelPrefixKey)})${getValueByPath(item, props.labelKey)}`
  } else {
    return getValueByPath(item, props.labelKey)
  }
}
</script>
<style lang="scss">
@import '../style/drawer-search-table-tag.scss';
</style>
